import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Button, Tooltip, Tag , Select} from 'antd';
import { AuditOutlined } from '@ant-design/icons';

import { pageSectionTitle } from '../util/Style';
import DatePicker from "react-datepicker";

const height = window.innerHeight * .74;

class RegenerateIc extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            value: ''
        };
    }


    handleChange = (dates) => {
        const [start, end] = dates;
        this.setState({
            startDate: start,
            endDate: end
        })

    }

    handleChangeInput = (event) => {
        this.setState({ value: event.target.value });

        this.store.referrerId = event.target.value;
    }

    setType = (value) => {
        this.store.settlementType = value;
        console.log(this.store.settlementType);
    }

    btnClicked = () => {

        this.store.regenerateIc(this.changeDateFormat(this.state.startDate), this.changeDateFormat(this.state.endDate));

        this.setState({ value: 0 });

    }


    changeDateFormat(date) {

        const yyyy = date.getFullYear();
        let mm = date.getMonth() + 1; // Months start at 0!
        let dd = date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedDate = dd + '/' + mm + '/' + yyyy;

        return formattedDate;

    }


    render() {

        return (
            <>
                <div>
                    <div style={{ display: 'inline-block' }}>
                        <PageHeader style={{ width: '100%', float: "left", paddingTop: 0 }} title={pageSectionTitle(this.props.title)} />
                    </div>

                </div>

                <div style={{ paddingTop: 0, height: height }} >

                    <div style={{ display: 'inline-block', width: '25%', marginTop: '5px', marginLeft: '5px' }}>
                        <input shape="round" style={{ border: "white", padding: "7px", width: "90%" }}
                            type="number" value={this.state.value} onChange={this.handleChangeInput} placeholder="Referrer ID" />
                    </div>

                    <div style={{ display: 'inline-block', width: '15%', marginTop: '5px', marginLeft: '5px', border: "white" }}>
                        <DatePicker shape="round" style={{ border: "white", color: "white", padding: "11px", width: "90%" }}
                            selected={this.state.startDate} onChange={this.handleChange} startDate={this.state.startDate} endDate={this.state.endDate} selectsRange dateFormat="dd/MM/yyyy" />
                    </div>

                    <Select style={{width: "20%"}} options={this.store.settlementTypeList} onChange={(value) => this.setType(value)} placeholder='Settlement Type' />

                    <div style={{ display: 'inline-block', width: '25%', float: 'right', marginTop: '5px' }}>
                        <Tooltip title="Regenerate IC For Doctor">
                            <Button shape="round" onClick={() => this.btnClicked()} style={{ background: "rgb(27,160,97)", color: "white" }} icon={<AuditOutlined />}>Regenerate IC</Button>
                        </Tooltip>
                    </div>

                </div>
            </>

        )
    }

}

export default observer(RegenerateIc)
